import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import { IS_PRODUCTION } from "./utils/env";
import App from "./App.tsx";
import "./global.css";

// Sentry 초기화 - 프로덕션 환경에서만 활성화
if (IS_PRODUCTION) {
  Sentry.init({
    dsn: "https://b602538c7b7fb511cf820d9426a6ef40@sentry.danver.io/7",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // 모든 텍스트와 입력필드, 미디어는 보이게 설정
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        // 비밀번호 필드와 기본 마스킹 클래스만 마스킹
        mask: ['input[type="password"]', ".sentry-mask", "[data-sentry-mask]"],
        // 기본 블록 선택자 유지 (필요시)
        block: [".sentry-block", "[data-sentry-block]"],
        // 특정 요소 언마스킹 (필요시)
        unmask: [".sentry-unmask", "[data-sentry-unmask]"],
        // 특정 미디어 언블록 (필요시)
        unblock: [".sentry-unblock", "[data-sentry-unblock]"],
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // 프로덕션에서는 100% 샘플링
    // CORS 문제를 피하기 위해 tracePropagationTargets 제거
    // tracePropagationTargets: ["localhost", /^https:\/\/api\.snscbt\.com/],
    // Session Replay
    replaysSessionSampleRate: 1.0, // 100% 의 세션을 캡처
    replaysOnErrorSampleRate: 1.0, // 에러 발생시 100% 캡처
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    // 환경 설정
    environment: "production",
  });
} else {
  console.log("🔧 Development mode: Sentry is disabled");
}

// React Query 클라이언트 생성
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // 창 포커스시 자동으로 refetch 하지 않음
      retry: 1, // 실패시 1번만 재시도
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
